




























import Vue, { PropType } from 'vue';
import { Cv, CvSectionLink, CvSectionLinkItem } from '@/../gen';
// @ts-ignore
import SectionPreviewField from '@/components/section-preview/SectionPreviewField.vue';

export default Vue.extend({
  components: {
    SectionPreviewField,
  },
  props: {
    cv: {
      type: Object as PropType<Cv>,
      required: true,
    },
    section: {
      type: Object as PropType<CvSectionLink>,
      required: true,
    },
    sectionItems: {
      type: Array as PropType<CvSectionLinkItem[]>,
      required: true,
    },
  },
});
